var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseAdminForm',{attrs:{"adminObject":_vm.admin,"formActionName":"إضافة المشرف"},on:{"adminSubmitted":function (submittedAdmin) { return _vm.sendAdminData(submittedAdmin); }}})}
var staticRenderFns = []

export { render, staticRenderFns }